export default __webpack_public_path__ + "static/media/Calibre-Regular.f4c4e8cc.woff";